
/**
 * Find the most attacked country from ransomware data
 */
export function findMostAttackedCountry(ransomwareData: any[]): string {
  const countryCounts: Record<string, number> = {};

  ransomwareData.forEach(attack => {
    if (attack.country) {
      const country = attack.country.trim();
      if (country !== '??' && country !== 'Unknown') {
        countryCounts[country] = (countryCounts[country] || 0) + 1;
      }
    }
  });

  let mostAttackedCountry = 'Unknown';
  let highestCount = 0;

  Object.entries(countryCounts).forEach(([country, count]) => {
    if (count > highestCount) {
      mostAttackedCountry = country;
      highestCount = count;
    }
  });

  return mostAttackedCountry;
}
